import(/* webpackMode: "eager", webpackExports: ["Redirector"] */ "/quick/apps/pwa/app/Redirector.tsx");
;
import(/* webpackMode: "eager" */ "/quick/apps/pwa/assets/img404.svg");
;
import(/* webpackMode: "eager", webpackExports: ["LangProvider","useLangProvider"] */ "/quick/apps/pwa/components/core/AppLayout/AppLangProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Boundary"] */ "/quick/apps/pwa/components/core/AppLayout/Boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Clarity"] */ "/quick/apps/pwa/components/core/AppLayout/Clarity.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CompatibilityNotice"] */ "/quick/apps/pwa/components/core/AppLayout/CompatibilityNotice.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieNotice"] */ "/quick/apps/pwa/components/core/AppLayout/CookieNotice.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DetectDVH"] */ "/quick/apps/pwa/components/core/AppLayout/DetectDVH.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EnvTag"] */ "/quick/apps/pwa/components/core/AppLayout/EnvTag.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FontConfig"] */ "/quick/apps/pwa/components/core/AppLayout/FontConfig.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HealthCheckAlert"] */ "/quick/apps/pwa/components/core/AppLayout/HealthCheckAlert.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeDetector"] */ "/quick/apps/pwa/components/core/AppLayout/ThemeDetector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useCSSHasLoader"] */ "/quick/apps/pwa/components/core/AppLayout/useCSSHasLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useValidateToken"] */ "/quick/apps/pwa/components/core/AppLayout/useValidateToken.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VersionAlert"] */ "/quick/apps/pwa/components/core/AppLayout/VersionAlert.tsx");
